import { useLocale } from '../../context';
import { IconRequestsEmpty } from '../VurgunIcons';

export default function RequestsEmptyState({ messageKey = 'account.requests.empty' }) {
  const _locale = useLocale();
  const tr = _locale.t;

  return (
    <div className="requests-empty">
      <span className="requests-empty__icon" aria-hidden="true">
        <IconRequestsEmpty />
      </span>
      <div className="requests-empty__caption">{tr(messageKey)}</div>
    </div>
  );
}
